import { render, staticRenderFns } from "./zhuanjia.vue?vue&type=template&id=22f30394&"
import script from "./zhuanjia.vue?vue&type=script&lang=js&"
export * from "./zhuanjia.vue?vue&type=script&lang=js&"
import style0 from "./zhuanjia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports